<template>
  <b-card>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button variant="primary" @click="ExportCsv()">Export CSV</b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block mr-1"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <!-- Table -->
      <b-table 
        responsive
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="contactRequest"
        :fields="fields"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="isBusy"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
            <strong class="text-secondary">Loading...</strong>
          </div>
        </template>
        <template #cell(action)="contactRequest">
          <div class="d-flex justify-content-start">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon"
              @click="confirmDeleteContactRequest(contactRequest.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
        <template #cell(createdat)="contactRequest">
          <div>
            {{
              contactRequest.item.createdat
                ? $moment(contactRequest.item.createdat).format('dddd, Do MMMM YYYY')
                : '-'
            }}
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <b-row
        v-if="!isBusy"
        v-for="(item, index) in contactRequest"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.name || '-' }}</strong>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon"
              @click="confirmDeleteContactRequest(item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>NIK:</strong> {{ item.nik || '-' }}</p>
            <p><strong>DIVISION:</strong> {{ item.division || '-' }}</p>
            <p><strong>EMAIL:</strong> {{ item.email || '-' }}</p>
            <p><strong>CATEGORY:</strong> {{ item.category || '-' }}</p>
            <p><strong>MESSAGE:</strong> {{ item.message || '-' }}</p>
            <p><strong>DATE:</strong> {{ item.createdat ? $moment(item.createdat).format('dddd, Do MMMM YYYY') : '-' }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
  },
  data() {
    return {
      token: "",
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      totalAll: 0,
      sortBy: 'CREATED_DATE',
      sortDesc: true,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'nik', label: 'NIK' },
        { key: 'division', label: 'Division' },
        { key: 'email', label: 'Email' },
        { key: 'category', label: 'Category' },
        { key: 'message', label: 'Message' },
        {
          key: 'createdat',
          formatter: (value, key, item) => {
            return this.$moment(value).format('YYYY-MM-DD H:mm')
          },
          label: 'Date',
          sortable: true,
        },
        'action',
      ],
      contactRequest: [],
      searchWord: '',
    }
  },

  directives: {
    Ripple,
  },

  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString().replace(/<[^>]*>?/gm, '');
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  watch: {
    perPage() {
      this.fetchContactRequest()
    },
    currentPage() {
      this.fetchContactRequest()
    },
    searchWord() {
      this.fetchContactRequest()
    },
  },

  mounted() {
    this.fetchContactRequest()
  },

  methods: {
    fetchContactRequest() {
      this.isBusy = true
      this.$http
        // .get('http://localhost:9999/contactUs', {
        .get(`${process.env.VUE_APP_API_HELPER_URL}/contactUs`, {
          params: {
            currentPage: this.currentPage,
            perPage: this.perPage,
            sort: this.sortDesc === true ? 'desc' : 'asc',
            search: this.searchWord.toString().trim(),
          },
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(({ data }) => {
          this.totalAll = data.pagination.total
          this.currentPage = data.pagination.current_page
          this.pagination.total = data.pagination.total
          this.pagination.from = data.pagination.from
          this.pagination.to = data.pagination.to
          this.contactRequest = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    changePage(page) {
      this.currentPage = page
    },
    async deleteContactRequest(contactRequestId) {
      this.isBusy = true
      return await this.$http
        // .delete(`http://localhost:9999/contactUs/${contactRequestId}`, {
        .delete(`${process.env.VUE_APP_API_HELPER_URL}/contactUs/${contactRequestId}`, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(res => {
          this.$notif(
            'Success',
            'Contact Request has been successfully deleted.',
            'success'
          )
        })
        .catch(({ data }) => {
          this.$notif('Something Error', data.message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    sortingChanged({ sortBy, sortDesc}) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.fetchContactRequest()
      }
    },
    confirmDeleteContactRequest(contactRequestId) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteContactRequest(contactRequestId).then(() => {
              this.fetchContactRequest()
            })
          }
        })
    },
    ExportCsv() {
      this.$http
        // .get('http://localhost:9999/contactUs', {
        .get(`${process.env.VUE_APP_API_HELPER_URL}/contactUs`, {
          params: {
            currentPage: 0,
            perPage: this.totalAll,
            sort: 'desc',
          },
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
        .then(({ data }) => {
          const headers = ['Name', 'NIK', 'Division', 'Email', 'Category', 'Message', 'Created At'];
          const value = []
          for(const item of data.data){
            value.push([
              item.name,
              item.nik,
              item.division,
              item.email,
              item.category,
              item.message,
              new Date(item.createdat).toLocaleString(),
            ])
          }

          const separator = ';'

          const csvContent = [
            headers.join(separator),
            ...value.map(row =>
              row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(separator)
            )
          ].join('\n')

          const bom = '\uFEFF'
          const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' })

          const url = URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.setAttribute('href', url)
          link.setAttribute('download', `export.csv`)
          link.click()
        })
        .finally(() => {
          this.isBusy = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
